import { useEffect, useState } from "react";

/** Use the stored deadline, never the analysed window or browser's timezone. */
export function ScenarioExpiryWarning({ expiresAt }: { expiresAt?: string | null }) {
  const [now, setNow] = useState(Date.now);
  const deadline = expiresAt ? Date.parse(expiresAt) : NaN;
  useEffect(() => {
    setNow(Date.now());
    if (!Number.isFinite(deadline)) return;
    const remaining = deadline - Date.now();
    if (remaining <= 0) return;
    const timer = window.setTimeout(() => setNow(Date.now()), Math.min(remaining, 2_147_483_647));
    return () => window.clearTimeout(timer);
  }, [deadline, now]);
  if (!Number.isFinite(deadline)) return null;
  const formatted = new Date(deadline).toISOString().replace("T", " ").replace(".000Z", " UTC").replace("Z", " UTC");
  return (
    <p role="status" className="mt-3 text-sm text-muted-foreground">
      {now >= deadline
        ? `This saved report and its generated files expired on ${formatted}. Identify scenarios again to create a new report.`
        : `This saved report and its generated files expire on ${formatted}. Download any files you want to keep before then. This seven-day retention also applies to longer-period sampled analyses.`}
    </p>
  );
}
